<template>
  <el-form ref="form" :model="innerForm" :rules="rules" label-width="140px">
    <el-form-item label="账号" v-if="duplicationState">
      <el-select :value="formData.ad_account_id" @change="onAccountChange" placeholder="请选择账号" style="width: 480px" filterable>
        <el-option v-for="item in accountData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="计划" v-if="duplicationState" prop="campaign_id">
      <el-select
        ref="campaignRef"
        v-model="formData.campaign_id"
        @change="onCampaignChange"
        placeholder="请选择计划"
        style="width: 480px"
        filterable
      >
        <el-option v-for="item in currTaskCampaignData" :key="item.adGroupId" :label="item.adGroupName" :value="item.adGroupId">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="计划组名称" prop="plan_name">
      <InputLen
        ref="planinput"
        v-model="innerForm.plan_name"
        placeholder="最大80个字符，1个中文等于2个字符"
        width="480"
        :max="80"
        :dyn-pos="dynpos"
      />
    </el-form-item>

    <el-form-item label="游戏平台">
      <RadioGroup v-model="innerForm.ch_platform_id" type="button">
        <Radio :label="p.value" v-for="p in KuaiShou.GAME_PLATFORM_LIST" :key="p.value" disabled>{{ p.label }}</Radio>
      </RadioGroup>
    </el-form-item>

    <el-form-item label="投放游戏">
      <Select v-model="innerForm.game_id" placeholder="请选择推广游戏" style="width: 360px" filterable disabled>
        <Option v-for="item in platformGameData" :key="item.id" :label="item.name" :value="item.id"></Option>
      </Select>
    </el-form-item>

    <el-form-item label="是否代投">
      <RadioGroup v-model="innerForm.agent" type="button">
        <Radio label="NOAGENT" disabled>非代投</Radio>
        <Radio label="AGENT" disabled>代投</Radio>
      </RadioGroup>
    </el-form-item>

    <el-form-item label="代投账号" v-if="innerForm.agent === 'AGENT'">
      <Select v-model="innerForm.proxy_account_id" placeholder="请选择代投账号" style="width: 360px" filterable disabled>
        <Option v-for="item in agentData" :key="item.id" :label="item.name" :value="item.id"></Option>
      </Select>
    </el-form-item>

    <el-form-item label="智能自动化">
      <select-monitor
        :data="innerForm.managePlan || []"
        :media="KuaiShou.MEDIA_ID"
        :open-id="opId"
        @on-delete="delButler"
        @on-select="appendButler"
        :disabled="editState"
      />
    </el-form-item>

    <el-form-item label="回调开关">
      <i-Switch v-model="innerForm.callback_switch" disabled :true-value="1" :false-value="0" />
      <span v-if="isIOS" style="color: #ff0000; margin-left: 1em">iOS请务必选择需要的回调类型</span>
      <span v-if="isMiniGame" style="color: #ff0000; margin-left: 1em">微信小程序必须要打开需要的回调类型</span>
    </el-form-item>
    <el-form-item label="回调开关" v-if="innerForm.callback_switch">
      <CheckboxGroup v-model="innerForm.callback_settings">
        <Checkbox label="callbackTypeActive" disabled>激活</Checkbox>
        <Checkbox label="callbackTypeRegist">注册</Checkbox>
        <Checkbox label="callbackTypeRecharge">付费</Checkbox>
        <Checkbox label="callbackTypeMoney">订单金额</Checkbox>
      </CheckboxGroup>
    </el-form-item>
  </el-form>
</template>
<script>
import InputLen from '@/components/input/input-len'
// import SelectButler from '@/components/select/select-butler.vue'
import SelectMonitor from '@/components/select/select-monitor.vue'
import KuaiShou from './data/index.class'
import { getCaoHuaGames, getCaoHuaAgent, adAccount } from '@/api/common.model'
import { isArray } from '@/common/js/utils'
import { makeBasicRules } from './data/form-rules.js'
import { queryGroupByAccountWithBudget } from '@/api/toutiao.local.model'
import { getCampaign } from '@/api/kuaishou.model'

export default {
  components: { InputLen, SelectMonitor },

  computed: {
    KuaiShou() {
      return KuaiShou
    },
    innerForm: {
      get() {
        return this.formData.innerForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_INNER_PARAMS', v)
      }
    },
    outterForm: {
      get() {
        return this.formData.outterForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_OUT_PARAMS', v)
      }
    },
    accounts() {
      return [
        {
          id: this.formData.ad_account_id,
          name: this.formData.ad_account_name
        }
      ]
    },
    editState() {
      return this.$route.path.includes('/edit/')
    },
    duplicationState() {
      return this.$route.path.includes('/duplicate/')
    },
    opId() {
      return this.formData.ad_account_id
    },
    formData: {
      get() {
        return this.$store.getters['Kuaishou/currTaskParams']
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_CURR_TASK', v)
      }
    },
    isLink() {
      return this.innerForm.landing_type === 'LINK'
    },

    platformGameData() {
      return this.gameData.filter((ret) => ret.ch_platform_id === this.innerForm.ch_platform_id) || []
    },
    isAndroid() {
      return this.innerForm.ch_platform_id === KuaiShou.GAME_PLATFORM.ANDROID
    },
    isIOS() {
      return this.innerForm.ch_platform_id === KuaiShou.GAME_PLATFORM.IOS
    },
    isMiniGame() {
      return this.innerForm.ch_platform_id === KuaiShou.GAME_PLATFORM.MINI_PROGRAME
    },
    bidType() {
      return this.outterForm.bid_type === 12 ? 1 : 0
    },

    currTaskCampaignData() {
      return this.campaignData[this.formData.taskId] || []
    }
  },
  watch: {
    'formData.taskId'() {
      if (this.duplicationState) {
        // 切换任务时，重新获取当前任务账号的广告计划列表
        this.getCampaignList()
      }
    }
  },
  data() {
    return {
      rules: { ...makeBasicRules.call(this) },
      dynpos: [],
      gameData: [],
      agentData: [],
      accountData: [],
      campaignData: {
        // 以任务id为key,保存各自任务账号下的广告计划列表数据
        // [taskId]: []
      }
    }
  },
  methods: {
    /**
     * @description: 切换广告计划时，根据广告组详情切换投放方式
     * @param {*} id
     */
    onCampaignChange(id) {
      getCampaign({ ad_account_id: this.formData.ad_account_id, id }).then((data) => {
        const { auto_adjust, auto_manage, auto_build } = data
        // 投放方式切换
        let deliveryMethod = 1

        // 自动化投放
        if (auto_manage && auto_build) {
          deliveryMethod = 3
        }

        // 智能调控
        if (auto_adjust && !(auto_manage && auto_build)) {
          deliveryMethod = 2
        }

        this.formData = {
          ...this.formData,
          deliveryMethod
        }
      })
    },
    /**
     * @description: 切换账号时，清除广告计划
     * @param {*} val
     */
    onAccountChange(val) {
      const account = this.accountData.find((ac) => ac.id === val)
      if (!account || !account.id) return this.$Message.warning('切换账号出错')

      const targetingForm = this.formData.targetingForm
      const newTargetingParam = targetingForm.targetingParam

      // 设置人群包为不限
      newTargetingParam.audienceMode = 'NONE'

      this.formData = {
        ...this.formData,
        ad_account_name: account.name,
        ad_account_id: account.id,
        campaign_id: '',
        targetingForm: {
          ...targetingForm,
          targetingParam: newTargetingParam
        }
      }

      // 获取账号下广告计划列表
      this.getCampaignList()
    },
    // 添加自动化规则回调
    appendButler(val) {
      this.innerForm = {
        ...this.innerForm,
        managePlan: val,
        plan_auto_task_id: Number(val[0].id),
        plan_auto_task_name: val[0].name
      }
    },
    // 删除自动化规则
    delMonitor() {
      const innerForm = Object.assign({}, this.innerForm)
      innerForm.monitorPlan = []
      innerForm.monitor_template_name = ''
      innerForm.monitor_template_id = ''
      this.innerForm = innerForm
    },

    delButler() {
      const innerForm = Object.assign({}, this.innerForm)
      innerForm.managePlan = []
      innerForm.plan_auto_task_name = ''
      innerForm.plan_auto_task_id = ''
      this.innerForm = innerForm
    },
    /**
     * @description: 根据账号id获取广告组
     */
    getCampaignList() {
      queryGroupByAccountWithBudget({
        adAccountId: this.formData.ad_account_id,
        bidType: this.bidType,
        campaignType: this.isLink ? 5 : 2,
        onlyBudgetLimitLess: false,
        // 根据投放方式过滤广告计划
        deliveryMethod: 'excludeAutoOfHasPlan'
      }).then((data) => {
        if (isArray(data)) {
          const { taskId, campaign_id } = this.formData
          this.$set(this.campaignData, taskId, data)

          // 当复制全自动计划时，campaign_id为空
          campaign_id && this.onCampaignChange(campaign_id)
        }
      })
    },
    setIcon() {
      const item = this.gameData.find((ret) => ret.id === this.innerForm.game_id)
      if (item?.icon) {
        this.innerForm = {
          ...this.innerForm,
          iconUrl: item.icon
        }
      }
    },
    preLoadData() {
      this.getCampaignList()

      Promise.all([getCaoHuaGames(), getCaoHuaAgent(), adAccount({ mediaId: KuaiShou.MEDIA_ID, authFlag: 1 })])
        .then((data) => {
          const [gameData, agentData, accountData] = data
          isArray(gameData) && (this.gameData = gameData)
          this.setIcon()
          isArray(agentData) && (this.agentData = agentData)
          isArray(accountData) && (this.accountData = accountData)
        })
        .catch((err) => console.log(err))
    },

    /**
     * @description: 表单校验
     * @return {*} 成功promise.resolve 失败promise.reject
     */
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          console.log('validvalidvalidvalid output: ', valid)
          if (valid) {
            resolve()
          } else {
            reject(new Error('basic'))
          }
        })
      })
    }
  },
  created() {
    // 加载数据源
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped></style>
